(() => {
  const fixCzechOrphans = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      if (node.parentElement?.closest('script, style, code, pre')) return;
      node.nodeValue = node.nodeValue.replace(/(?<!\p{L})([AaIiKkOoSsUuVvZz])\s+(?=\S)/gu, '$1\u00a0');
    });
  };

  document.querySelectorAll('.cb-article__body, .cb-article__lead, .cb-article__faq-answer').forEach(fixCzechOrphans);

  const publish = (name, payload = {}) => {
    if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(name, payload);
    window.dataLayer?.push({ event: name, ...payload });
  };

  document.addEventListener('click', (event) => {
    const cta = event.target.closest('[data-cb-product-cta]');
    if (cta) publish('article_product_cta_click', { article_url: location.pathname, product_url: cta.href });

    const articleLink = event.target.closest('[data-cb-article-link]');
    if (articleLink) {
      const placement = articleLink.dataset.cbArticleLink;
      const name = placement === 'sidebar' ? 'article_sidebar_click' : placement === 'related' ? 'article_related_click' : 'blog_article_click';
      publish(name, { source_url: location.pathname, destination_url: articleLink.href });
    }
  });

  document.addEventListener('toggle', (event) => {
    const faq = event.target.closest('[data-cb-faq]');
    if (faq?.open) publish('article_faq_open', { article_url: location.pathname, question: faq.dataset.cbFaq });
  }, true);
})();
